import * as defaultImport from "@splunk/react-icons/SVG";
export * from "@splunk/react-icons/SVG";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
